import React, { useMemo } from "react";
import { useWebsite } from "../../../Context/WebSiteContext";

const FooterModern = ({ config }) => {
  const { formData } = useWebsite();

  const mergedConfig = useMemo(
    () => ({
      ...config,
      ...formData,
    }),
    [config, formData]
  );

  console.log("Merged Config:", mergedConfig);
  console.log("Form Data:", formData);

  const { logo, footer } = mergedConfig || {};

  // COR DE FUNDO
  let navColorRaw = formData?.navbar?.colornav || config?.navbar?.colornav;
  let navColor = typeof navColorRaw === "string" ? navColorRaw.trim() : "";
  if (!navColor.startsWith("#")) navColor = `#${navColor}`;
  if (navColor.length !== 7 && navColor.length !== 4) navColor = "#ffffff";

  // COR DO TEXTO
  let textColorRaw =
    formData?.navbar?.colornavtext || config?.navbar?.colornavtext;
  let textColor = typeof textColorRaw === "string" ? textColorRaw.trim() : "";
  if (!textColor.startsWith("#")) textColor = `#${textColor}`;
  if (textColor.length !== 7 && textColor.length !== 4) textColor = "#000000";

  return (
    <footer
      className="footer-modern d-flex flex-column align-items-center justify-content-center"
      style={{
        background: navColor,
        color: textColor,
        padding: "32px 0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 40,
        flexWrap: "wrap",
      }}
    >
      <div className="col w-100 d-flex justify-content-center align-items-center gap-3">
        <div className="d-flex justify-content-center">
          {logo && (
            <img
              src={logo}
              alt="Logo"
              style={{
                height: 86,
                objectFit: "contain",
                borderRadius: 8,
                padding: 8,
              }}
            />
          )}
        </div>

        <div className="d-flex flex-column align-items-start">
          <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 8 }}>
            {footer?.endereco}
          </div>
          <div className="d-flex flex-row gap-4 align-items-center justify-content-start">
            <span>
              <i className="bi bi-whatsapp" /> {footer?.telefone}
            </span>
            <span>
              <i className="bi bi-envelope" /> {footer?.email}
            </span>
            <div>
              {footer?.facebook && (
                <a
                  href={`https://facebook.com/${footer.facebook}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: textColor,
                    fontSize: 15,
                  }}
                >
                  <i className="bi bi-instagram" />
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterModern;
